import { CSSProperties } from 'react';
import { observer } from 'mobx-react-lite';
import { ImageMeta } from 'nfty-common/lib/model/image-set';

const imageStyle: CSSProperties = {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
};

interface KenBurnsImageProps {
    image?: ImageMeta;
}

export const KenBurnsImage = observer((props: KenBurnsImageProps) => {
    const { image } = props;

    if (image) {
        return (
            <div style={{ width: image.width, marginLeft: `-${image.width / 2}` }} className="h-100">
                <img style={imageStyle} className="kenburns-right" src={image.data} alt="main artwork" />
            </div >
        );
    } else {
        return (null);
    }
});